var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 41,
    viewBox: "0 0 99 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2466 16.0071V27.6049H31.8969V0.236068H40.2466L48.5125 16.0071H40.2466ZM8.57853 6.44242V27.6049H0V0H28.1757V27.6049H19.5972V6.44242H8.57853ZM69.1086 0.236068V27.6049H60.7588V15.9157L68.9713 0.243685H69.1086V0.236068ZM86.1055 40.9924H83.9552V32.2426H89.5522V34.1159H86.1132V40.9924H86.1055ZM77.0314 40.9924H74.881V32.2426H77.0314V35.677H79.6621V32.2426H81.8125V40.9924H79.6621V37.558H77.0314V40.9924ZM67.7055 40.9924H65.7306V32.2426H67.8809V37.1163L70.7633 32.2426H72.7383V40.9924H70.5879V36.1187L67.7055 40.9924ZM59.6837 34.1235V36.0197H61.1859C61.3994 36.0197 61.59 35.9435 61.7425 35.7836C61.895 35.6237 61.9713 35.3952 61.9713 35.083C61.9713 34.7708 61.895 34.5347 61.7425 34.3672C61.59 34.1997 61.3994 34.1159 61.1859 34.1159H59.6837V34.1235ZM59.6837 40.9924H57.5333V32.2426H61.6052C62.4059 32.2426 63.0312 32.4939 63.4811 32.9965C63.931 33.4991 64.1597 34.1844 64.1597 35.0602C64.1597 35.9359 63.931 36.6289 63.4811 37.1391C63.0312 37.6493 62.4059 37.9006 61.6052 37.9006H59.6913V41L59.6837 40.9924ZM50.3578 40.9924H48.3829V32.2426H50.5332V37.1163L53.4156 32.2426H55.3906V40.9924H53.2402V36.1187L50.3578 40.9924ZM41.4591 40.9924H39.3087V32.2426H41.4591V35.677H44.0898V32.2426H46.2402V40.9924H44.0898V37.558H41.4591V40.9924ZM32.1332 40.9924H30.1583V32.2426H32.3086V37.1163L35.191 32.2426H37.166V40.9924H35.0156V36.1187L32.1332 40.9924ZM24.2105 40.9924H22.0449V37.558H21.2214L19.4447 40.9924H17.3934V40.2918L19.4447 36.5071L17.6069 32.9584V32.2426H19.4752L21.2061 35.677H22.0602V32.2426H24.2258V35.677H25.0798L26.8108 32.2426H28.679V32.9584L26.8413 36.5071L28.8925 40.2918V40.9924H26.8413L25.0645 37.558H24.241V40.9924H24.2105ZM11.3008 40.9924H9.15043V32.2426H11.3008V35.677H13.9315V32.2426H16.0819V40.9924H13.9315V37.558H11.3008V40.9924ZM1.98259 40.9924H0.00762408V32.2426H2.15797V37.1163L5.04036 32.2426H7.01533V40.9924H4.86498V36.1187L1.98259 40.9924ZM71.4801 0H99V6.44242H89.5522V27.6049H80.9279V6.44242H71.4801V0Z",
    fill: "#3B4B66"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_577_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 0,
    width: 20,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6294 0.236328L50.4419 19.6778L54.5901 27.5976H54.6358L69.1164 0.236328H60.6294Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_577_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.1164 0.236328H50.4419V27.6052H69.1164V0.236328Z",
    fill: "url(#paint0_linear_577_92)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5125 16.0073L54.5899 27.5976H46.2783L40.239 16.0073H44.4787H48.5125Z",
    fill: "#E5310E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_92",
    x1: 53.4234,
    y1: 20.0357,
    x2: 51.1921,
    y2: 22.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5310E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E2900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtm);
export default __webpack_public_path__ + "static/media/ptm.6122f73a929396caf490e13d4f490abf.svg";
export { ForwardRef as ReactComponent };